import { useState } from "react";
import Button from "../../components/button";
import Modal from "../../components/modal";
import Styles from "./styles.module.scss"
import { convertMilliSecToDateNew } from "../../utils/EllowUtils";
import FulltimeDetails from "../fullTimeDetails";

interface props {
    onClose: any
    ClickHandler: any
    defaultvalues: any
    buttonName: any
    allRecruiters: any
    allocatedTo: any
}


const  FulltimeInfoModal: React.FC<props> = ({
    onClose,
    ClickHandler,
    defaultvalues,
    buttonName,
    allRecruiters,
    allocatedTo
}) => {

    const [editModal, setEditModal] = useState<any>(false)

    const submitEditModal = (data: any) => {
        setEditModal(false)
        ClickHandler(data)
    }
 
    return (
      <Modal title="" size="medium" onClose={onClose}>
                { editModal && <FulltimeDetails onClose={() => setEditModal(false)} ClickHandler={submitEditModal} defaultvalues={defaultvalues} buttonName={'Edit'} allocatedTo={allocatedTo} allRecruiters={allocatedTo}/>}
        <div className={Styles.basicInfoCard}>
            <div className={Styles.cardItrem}>
                <div className={Styles.form}>
                        <label>Position closed by:</label>
                        {defaultvalues[0].contractMetadata && defaultvalues[0].contractMetadata.closedBy}
                </div>
                <div className={Styles.form}>
                    <label>Candidate applied by:</label>
                    {defaultvalues[0].contractMetadata && defaultvalues[0].contractMetadata.candidateAppliedBy}
                </div>
            </div>
            <div className={Styles.cardItrem}>
                <div className={Styles.form}>
                    <label>Salary offered to the candidate:</label>
                  {defaultvalues[0].contractMetadata && defaultvalues[0].contractMetadata.salaryOffered}
                </div>
            </div>
            <div className={Styles.cardItrem}>
                <div className={Styles.form}>
                    <label>Notice period of the candidate in weeks:</label>
                    {defaultvalues[0].contractMetadata && defaultvalues[0].contractMetadata.noticePeriod}
                </div>
                </div>
                <div className={Styles.cardItrem}>
                <div className={Styles.form}>
                    <label>Date of joining:</label>
                    {defaultvalues[0].contractMetadata && convertMilliSecToDateNew(defaultvalues[0].contractMetadata.dateOfJoining)}
                </div>
            </div>
        </div> 
            <div className="subAction">
                <div className={Styles.popupAction}>
                    <Button variant='secondary'  onClick={onClose}>Cancel</Button>
                    <Button variant='primary' onClick={() => setEditModal(true)} >Edit</Button>
              
                </div>
            </div> 
    </Modal>
    )
}
export default  FulltimeInfoModal

